
        import * as module0 from './controllers/example_controller.js';import * as module1 from './controllers/mobile_nav_controller.js'
        const modules = {
            "./controllers/example_controller.js": module0,
            "./controllers/mobile_nav_controller.js": module1,
        };
        export default modules;
      